import React from "react";
import { Send, Check, Archive, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

// Bulk-action toolbar shown when one or more nodes are selected.
export const BulkActions = ({ count, isAdmin, onSubmit, onApprove, onArchive, onDelete, onClear }) => (
  <div className="flex items-center gap-2 mb-3 bg-primary/5 border border-primary/20 rounded-lg px-4 py-2" data-testid="bulk-toolbar">
    <span className="text-sm font-medium text-foreground mr-1">{count} selected</span>
    <Button size="sm" variant="outline" onClick={onSubmit} data-testid="bulk-submit-btn">
      <Send className="w-3.5 h-3.5 mr-1" /> Submit
    </Button>
    <Button size="sm" variant="outline" onClick={onApprove} data-testid="bulk-approve-btn">
      <Check className="w-3.5 h-3.5 mr-1" /> Approve
    </Button>
    <Button size="sm" variant="outline" onClick={onArchive} data-testid="bulk-archive-btn">
      <Archive className="w-3.5 h-3.5 mr-1" /> Archive
    </Button>
    {isAdmin && (
      <Button size="sm" variant="outline" className="text-destructive" onClick={onDelete} data-testid="bulk-delete-btn">
        <Trash2 className="w-3.5 h-3.5 mr-1" /> Delete
      </Button>
    )}
    <Button size="sm" variant="ghost" onClick={onClear} className="ml-auto" data-testid="bulk-clear-btn">Clear</Button>
  </div>
);
